"use client";

import { useState } from 'react';
import Logo from '@/components/common/Logo';
import Link from 'next/link';
import { useAuth } from '@/contexts/AuthContext';

export default function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const { user, signOut } = useAuth();

    const handleSignOut = async () => {
        try {
            await signOut();
        } catch (error) {
            console.error('Sign out error:', error);
        }
    };

    return (
        <header className="bg-dark-green-700 border-b-2 border-dark-green-800">
            <nav className="max-w-7xl mx-auto px-3 py-2">
                {/* Logo */}
                <div className="mb-2">
                    <Link href="/homepage" className="text-white text-xl font-bold hover:text-dark-green-100">
                        American Calculators
                    </Link>
                </div>
                
                {/* Desktop Navigation - Calculator.net style */}
                <div className="hidden md:block">
                    <div className="flex flex-wrap gap-x-2 gap-y-1 text-sm items-center">
                        <Link href="/homepage" className="text-white hover:text-dark-green-100 font-semibold">
                            home
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/financial-calculators" className="text-white hover:text-dark-green-100">
                            Financial Calculators
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/fitness-health-calculators" className="text-white hover:text-dark-green-100">
                            Fitness and Health Calculators
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/math-calculators" className="text-white hover:text-dark-green-100">
                            Math Calculators
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/date-time-calculators" className="text-white hover:text-dark-green-100">
                            Date and Time Calculators
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/housing-building-calculators" className="text-white hover:text-dark-green-100">
                            Housing/Building Calculators
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/measurements-conversions" className="text-white hover:text-dark-green-100">
                            Measurements & Conversions
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/converters" className="text-white hover:text-dark-green-100">
                            Converters
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/credit-card-calculators" className="text-white hover:text-dark-green-100">
                            credit cards
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/loan-calculators" className="text-white hover:text-dark-green-100">
                            loans
                        </Link>
                        <span className="text-dark-green-400">|</span>
                        <Link href="/insurance-calculators" className="text-white hover:text-dark-green-100">
                            insurance
                        </Link>
                        {user && (
                            <>
                                <span className="text-dark-green-400">|</span>
                                <Link href="/saved-calculations" className="text-white hover:text-dark-green-100">
                                    my saved
                                </Link>
                            </>
                        )}
                        {user ? (
                            <>
                                <span className="text-dark-green-400">|</span>
                                <button onClick={handleSignOut} className="text-white hover:text-dark-green-100">
                                    sign out
                                </button>
                            </>
                        ) : (
                            <>
                                <span className="text-dark-green-400">|</span>
                                <Link href="/login" className="text-white hover:text-dark-green-100">
                                    sign in
                                </Link>
                            </>
                        )}
                    </div>
                </div>

                {/* Mobile Menu Button */}
                <button 
                    className="md:hidden text-white text-sm underline font-semibold"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    {mobileMenuOpen ? 'close menu' : 'menu'}
                </button>
            </nav>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="md:hidden bg-dark-green-800 border-t border-dark-green-900">
                    <div className="max-w-7xl mx-auto px-3 py-3 space-y-2 text-sm">
                        <Link href="/homepage" className="block text-white hover:text-dark-green-100 font-semibold" onClick={() => setMobileMenuOpen(false)}>
                            home
                        </Link>
                        <Link href="/financial-calculators" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            Financial Calculators
                        </Link>
                        <Link href="/fitness-health-calculators" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            Fitness and Health Calculators
                        </Link>
                        <Link href="/math-calculators" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            Math Calculators
                        </Link>
                        <Link href="/date-time-calculators" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            Date and Time Calculators
                        </Link>
                        <Link href="/housing-building-calculators" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            Housing/Building Calculators
                        </Link>
                        <Link href="/measurements-conversions" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            Measurements & Conversions
                        </Link>
                        <Link href="/converters" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            Converters
                        </Link>
                        <Link href="/credit-card-calculators" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            credit cards
                        </Link>
                        <Link href="/loan-calculators" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            loans
                        </Link>
                        <Link href="/insurance-calculators" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                            insurance
                        </Link>
                        {user && (
                            <Link href="/saved-calculations" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                                my saved calculations
                            </Link>
                        )}
                        {user ? (
                            <button onClick={() => { handleSignOut(); setMobileMenuOpen(false); }} className="block text-white hover:text-dark-green-100">
                                sign out
                            </button>
                        ) : (
                            <Link href="/login" className="block text-white hover:text-dark-green-100" onClick={() => setMobileMenuOpen(false)}>
                                sign in
                            </Link>
                        )}
                    </div>
                </div>
            )}
        </header>
    );
}